import $ from 'jquery';

$(function() {
    $('.buy').on('click', function() {
        let checkbox = $('input[type=checkbox]');
        checkbox.prop('checked', false);
    });
    $('.rent').on('click', function() {
        let checkbox = $('input[type=checkbox]');
        checkbox.prop('checked', true);
    });
});